import React, { Component } from 'react';
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer } from 'recharts';
import { Card, Row, Col,Button } from 'reactstrap';
import { OVERALL, PAYMENT_DELINQUENCY, PAYMENT_DELINQUENCY_DESCRIPTION } from '../constants';
import { getFilterType } from './util';


class PaymentDelinquencyChart extends Component {

  state = {
    lineChartProperties: {
      with_me_color: '#203864', with_cug_member_color: '#ff0000', cug_group_color: '#ffff00', portfolio_color: '#35e33d'
    },
    selectedfilter: OVERALL, filteredData : []
  }

  componentDidMount() {
    if (this.props.chartData) {
      this.setState({ chartData: this.props.chartData }, ()=>{
        setTimeout( ()=> this.filterData(), 2500);
        
      })
    }
  }

  handleTypeFilter = (e) => {
    if (this.state.selectedfilter !== e.target.value) {
      this.setState({ selectedfilter: e.target.value }, ()=>{
        this.filterData();
      })
    }
    e.preventDefault();
  }

  filterData = () => {
    let type = getFilterType(this.state.selectedfilter);
    let filteredData = this.props.chartData.filter(objdata => objdata.type == type);
    this.setState({ filteredData: filteredData })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.chartData !== this.props.chartData){
      this.filterData();
    }
  }
  
  render() {
    return (
        <Card body className='mt-3'>
          <div>
            <h3 className='text-center'>
              {PAYMENT_DELINQUENCY}
            </h3>

            {
              this.props.typeFilters 
              && this.props.typeFilters.length > 0 
              && <select className='position-absolute chart-filter-dropdown' name="typefilter" onChange={(e) => this.handleTypeFilter(e)} value={this.state.selectedfilter}> 
                {this.props.typeFilters.map(optionValue => (<option value={optionValue} key={Math.random()}  >{optionValue}</option>))}
              </select>
            }
          </div>
          <ResponsiveContainer width='100%' height={300}>
            <LineChart data={this.state.filteredData} 
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}  >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend style={{ marginTop: `5px !important` }} />
              <Line type="monotone" dataKey="me" stroke={this.state.lineChartProperties.with_me_color} name={`${this.props.counterpartyName} (With Me)`} strokeWidth={2} />
              <Line type="monotone" dataKey="cug_member" stroke={this.state.lineChartProperties.with_cug_member_color} name={`${this.props.counterpartyName} (With Other CUG Members)`} strokeWidth={2} />
              <Line type="monotone" dataKey="portfolio" stroke={this.state.lineChartProperties.portfolio_color} name={`${this.props.corporateName} Portfolio`} strokeWidth={2} />
              <Line type="monotone" dataKey="cug" stroke={this.state.lineChartProperties.cug_group_color} name={"CUG Group"} strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
          
          <details>
              <summary>
                  <i>Know more...</i>
              </summary>
              <p dangerouslySetInnerHTML={{ __html: PAYMENT_DELINQUENCY_DESCRIPTION }}></p>
          </details>
        </Card>
    );
  }
}

export default PaymentDelinquencyChart;